<script setup lang="ts">
import type { IRate } from "~/interfaces";
const locale = await getLocale("forms", "rate_power_credit");
import { removeZeroDecimals } from "~/utils/prices";

import BaseForm from "~/components/ui/BaseForm.vue";
import Rata from "~/components/inputs/Rata.vue";

defineComponent({
  name: "RatePowerCreditUpgrade",
});

const { selectedModel } = defineProps({
  selectedModel: {
    type: String,
    default: 'upgrade'
  }
})

const emit = defineEmits(["init", "submit", "upgradeRateValue"]);

const model = ref<IRate>(getPromoModel()!);
const upgradeModel = ref<IRate>(getPromoUpgradeModel()!);
const selected = ref<IRate>(selectedModel === 'upgrade' ? upgradeModel.value : model.value);

const impRata = computed(() => {
  return removeZeroDecimals(model.value.imp_rata)
});

const text = computed(() => {
  return `Rata <strong>${impRata.value} €</strong> per <strong>${model.value.rate}</strong> mesi <strong>TAEG ${model.value.taeg}%</strong>`
});

const textAlt = computed(() => {
  return `<span class="lg:hidden"><strong>${model.value.imp_finanz}</strong> €</span> <span class="md:capitalize">rata</span> <strong>${impRata.value} €</strong> per <strong>${model.value.rate}</strong> mesi TAEG <strong>${model.value.taeg}%</strong>`
});

const textUpgrade = computed(() => {
  return `Rata <strong>${upgradeModel.value.imp_rata} €</strong> TAEG <strong>${upgradeModel.value.taeg}%</strong>`
});

const textUpgradeAlt = computed(() => {
  return `<span class="lg:hidden"><strong>${upgradeModel.value.imp_finanz}</strong> €</span> <span class="md:capitalize">rata</span> ${upgradeModel.value.imp_rata} € TAEG ${upgradeModel.value.taeg}%`
});

const isActive = (model: IRate) => {
  return selected.value === model
};
const toggleSelected = (rate: IRate) => {
  if (window.innerWidth < 1024) selected.value = rate;
};

const submit = (model: IRate, hasUpgraded = false) => {
  emit("submit", model, hasUpgraded);
};
onMounted(() => emit("init"));
</script>

<template>
  <BaseForm>
    <template #upper>
      <div class="offers my-4 sm:my-8">
        <div class="px-6 pt-4">
            <h2
              class="pageTitle !text-center"
            >
              {{ locale.title_power_upgrade }}
            </h2>
            <h3 class="pageSubtitle !text-center mt-3">
              {{ locale.subtitle_power_upgrade }}
            </h3>
          </div>
        <div class="px-4 sm:px-6 lg:px-12 pt-3">
          <div class="mb-6" data-testid="rataOur2000">
            <Rata
              class="mb-2"
              :model="upgradeModel"
              :active="isActive(upgradeModel)"
              :text="textUpgrade"
              :text-alt="textUpgradeAlt"
              type="our"
              @selected="toggleSelected"
              @submit="submit(upgradeModel, true)"
            />
          </div>
          <p class="text-center py-6">{{ locale.or_continue_with }}</p>
          <ul class="mb-6" data-testid="rataOur600">
            <Rata
              :model="model"
              :active="isActive(model)"
              type="our"
              :text="text"
              :text-alt="textAlt"
              @selected="toggleSelected"
              @submit="submit"
            />
          </ul>
        </div>
      </div>
      <div class="spacer h-6" />
    </template>
  </BaseForm>
</template>

<style scoped></style>
